import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=b72f0228"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/applications/abenity.com-cb0cd5ae/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b72f0228')) {
      api.createRecord('b72f0228', component.options)
    } else {
      api.reload('b72f0228', component.options)
    }
    module.hot.accept("./Base.vue?vue&type=template&id=b72f0228", function () {
      api.rerender('b72f0228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/vue-components/Base.vue"
export default component.exports